import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import type { BasePageState } from '../../types/base';
import type { TopicAction } from '@stores/topic/action';
import type { ActivityAction } from '@stores/activity/action';


interface SearchProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    topic?: TopicAction;
    activity?: ActivityAction;
}
interface SearchState extends BasePageState {
    navList: any
    navCurrentIndex: any
    navCurrentType: any
    searchTopicList: any
    topicPage: any   // 话题当前分页
    topicPerPage: any   // 话题当前每页条数
    topicTotalCount: any // 搜索到的话题总数
    searchUserList: any
    userPage: any   // 用户当前分页
    userPerPage: any   // 用户当前每页条数
    userTotalCount: any // 搜索到的用户总数
    searchActivityList: any
    activityPage: any   // 活动当前分页
    activityPerPage: any   // 活动当前每页条数
    activityTotalCount: any // 搜索到的活动总数
    searchThreadList: any //帖子列表
    threadPage: any   // 帖子当前分页
    threadPerPage: any   // 帖子当前每页条数
    threadTotalCount: any // 搜索到的帖子总数
}
@inject('app', 'site', 'user', 'thread', 'topic', 'activity')
@observer
class Search extends BasePage<SearchProps, SearchState> {
    namespace = 'searchAll';
    searchValue: any = '';   // 搜索框的值
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        navList: [
            { name: '综合', id: 0, type: '', namespace: 'searchAll' },
            { name: '话题', id: 1, type: '1', namespace: 'topicList' },
            { name: '用户', id: 2, type: '2', namespace: 'searchUserList' },
            { name: '活动', id: 3, type: '3', namespace: 'activityList' },
            { name: '帖子', id: 4, type: '4', namespace: 'searchThreadList' },
        ],
        navCurrentIndex: 0, // 导航当前选中索引
        navCurrentType: 0,  // 导航当前选中类型
        searchTopicList: [],    // 搜索到的话题列表
        topicPage: 1,   // 话题当前分页
        topicPerPage: 3,   // 话题当前每页条数
        topicTotalCount: 0, // 搜索到的话题总数
        searchUserList: [],    // 搜索到的用户列表
        userPage: 1,   // 用户当前分页
        userPerPage: 8,   // 用户当前每页条数
        userTotalCount: 0, // 搜索到的用户总数
        searchActivityList: [],    // 搜索到的活动列表
        activityPage: 1,   // 活动当前分页
        activityPerPage: 2,   // 活动当前每页条数
        activityTotalCount: 0, // 搜索到的活动总数
        searchThreadList: [],    // 搜索到的帖子列表
        threadPage: 1,   // 帖子当前分页
        threadPerPage: 5,   // 帖子当前每页条数
        threadTotalCount: 0, // 搜索到的帖子总数
    };
    componentDidMount() {
        // const { app, user, thread, match } = this.props;
        const routerParams = new URLSearchParams(this.props.location.search);
        console.log(routerParams?.get('keyword'), '搜索框的值');
        this.searchValue = routerParams?.get('keyword') || '';
        this.getAllTypeData();
        
        super.componentDidMount();
    }

    componentDidUpdate(prevProps: any) {
        // 监听路由参数变化，如果 keyword 参数改变，重新加载数据
        const prevParams = new URLSearchParams(prevProps.location?.search || '');
        const currentParams = new URLSearchParams(this.props.location?.search || '');
        
        const prevKeyword = prevParams.get('keyword');
        const currentKeyword = currentParams.get('keyword');
        
        // 只有当 keyword 参数实际发生变化时才重新加载数据
        if (prevKeyword !== currentKeyword) {
            this.searchValue = currentKeyword || '';
            this.setState({
                navCurrentIndex: 0,
            }, () => {
                this.navClick('', 0);
                // this.getAllTypeData();
            })
            
        }
        
    }

    // 综合时，获取所有初始化数据
    getAllTypeData = () => {
        const { app } = this.props;
        let { navCurrentIndex } = this.state;
        const platform = app?.platform || 'h5';
        
        if(platform == 'h5') {
            this.setState({
                searchTopicList: [],    // 搜索到的话题列表
                topicPage: 1,   // 话题当前分页
                topicPerPage: 3,   // 话题当前每页条数
                topicTotalCount: 0, // 搜索到的话题总数
                searchUserList: [],    // 搜索到的用户列表
                userPage: 1,   // 用户当前分页
                userPerPage: 12,   // 用户当前每页条数
                userTotalCount: 0, // 搜索到的用户总数
                searchActivityList: [],    // 搜索到的活动列表
                activityPage: 1,   // 活动当前分页
                activityPerPage: 1,   // 活动当前每页条数
                activityTotalCount: 0, // 搜索到的活动总数
                searchThreadList: [],    // 搜索到的帖子列表
                threadPage: 1,   // 帖子当前分页
                threadPerPage: 5,   // 帖子当前每页条数
                threadTotalCount: 0, // 搜索到的帖子总数
            }, () => {
                if(navCurrentIndex == 0) {  // 是综合，一次请求四个类型的接口，均是初始化第一页的数据
                    this.getTopicList();
                    this.getUserList();
                    this.getActivityList();
                    this.getThreadList();
                }
            })
        }   else {
            if(navCurrentIndex == 0) {  // 是综合，一次请求四个类型的接口，均是初始化第一页的数据
                this.setState({
                    searchTopicList: [],    // 搜索到的话题列表
                    topicPage: 1,   // 话题当前分页
                    topicPerPage: 3,   // 话题当前每页条数
                    topicTotalCount: 0, // 搜索到的话题总数
                    searchUserList: [],    // 搜索到的用户列表
                    userPage: 1,   // 用户当前分页
                    userPerPage: 8,   // 用户当前每页条数
                    userTotalCount: 0, // 搜索到的用户总数
                    searchActivityList: [],    // 搜索到的活动列表
                    activityPage: 1,   // 活动当前分页
                    activityPerPage: 2,   // 活动当前每页条数
                    activityTotalCount: 0, // 搜索到的活动总数
                    searchThreadList: [],    // 搜索到的帖子列表
                    threadPage: 1,   // 帖子当前分页
                    threadPerPage: 5,   // 帖子当前每页条数
                    threadTotalCount: 0, // 搜索到的帖子总数
                }, () => {
                    this.getTopicList();
                    this.getUserList();
                    this.getActivityList();
                    this.getThreadList();
                })
                
            }
        }
    }


    // 跳转到详情页，item是数据，type为类型，1是话题，2是用户，3是活动，4是帖子
    handleDetailClick = (item, type) => {
        let { history } = this.props;
        if(type == 1) {
            history && history.push(`/topicDetail/${item?.id}`);
        } else if (type == 2) {
            history && history.push(`/user/${item?.id}`);
        } else if (type == 3) {
            // history && history.push(`/activityDetail/${item?.id}`);
            window.open(`/threadDetail/${item.id}`);
        } else {
            // history && history.push(`/threadDetail/${item?.id}`);
            window.open(`/threadDetail/${item.id}`);
        }
    }

    // 关注用户
    createFollowUser = (item, index) => {
        console.log('关注参数', item, index);
        const { user } = this.props;
        if (user) {
            let params: any = {
                toUserCode: item?.code
            }
            user.createFollowUser(params).then(res => {
                if(res.code == 0) {
                    
                }
            })
        }
    }

    // 取消关注用户
    followDelete = (item, index) => {
        console.log('取消关注参数', item, index);
        const { user } = this.props;
        if (user) {
            let params: any = {
                code: item?.code,
                type: 1
            }
            user.followDelete(params).then(res => {
                if(res.code == 0) {
                    
                }
            })
        }
    }

    // 导航点击，类型切换
    navClick = (item: any, index: any) => {
        // 全部初始化
        this.namespace = item.namespace;
        this.setState({
            searchTopicList: [],    // 搜索到的话题列表
            topicPage: 1,   // 话题当前分页
            topicPerPage: 0,   // 话题当前每页条数
            topicTotalCount: 0, // 搜索到的话题总数
            searchUserList: [],    // 搜索到的用户列表
            userPage: 1,   // 用户当前分页
            userPerPage: 0,   // 用户当前每页条数
            userTotalCount: 0, // 搜索到的用户总数
            searchActivityList: [],    // 搜索到的活动列表
            activityPage: 1,   // 活动当前分页
            activityPerPage: 0,   // 活动当前每页条数
            activityTotalCount: 0, // 搜索到的活动总数
            searchThreadList: [],    // 搜索到的帖子列表
            threadPage: 1,   // 帖子当前分页
            threadPerPage: 0,   // 帖子当前每页条数
            threadTotalCount: 0, // 搜索到的帖子总数
            navCurrentIndex: index,
            navCurrentType: item.type,
            
        }, () => {
            if(index == 0) {    // 是综合
                this.getAllTypeData();
            } else if(index == 1) { // 是话题
                this.setState({
                    searchTopicList: [],    // 搜索到的话题列表
                    topicPage: 1,   // 话题当前分页
                    topicPerPage: 10,   // 话题当前每页条数
                    topicTotalCount: 0, // 搜索到的话题总数
                }, () => {
                    this.getTopicList();
                })
            } else if(index == 2) { // 是用户
                this.setState({
                    searchUserList: [],    // 搜索到的用户列表
                    userPage: 1,   // 用户当前分页
                    userPerPage: 20,   // 用户当前每页条数
                    userTotalCount: 0, // 搜索到的用户总数
                }, () => {
                    this.getUserList();
                })
            } else if(index == 3) { // 是活动
                this.setState({
                    searchActivityList: [],    // 搜索到的活动列表
                    activityPage: 1,   // 活动当前分页
                    activityPerPage: 10,   // 活动当前每页条数
                    activityTotalCount: 0, // 搜索到的活动总数
                }, () => {
                    this.getActivityList();
                })
            } else {  // 是帖子
                this.setState({
                    searchThreadList: [],    // 搜索到的帖子列表
                    threadPage: 1,   // 帖子当前分页
                    threadPerPage: 20,   // 帖子当前每页条数
                    threadTotalCount: 0, // 搜索到的帖子总数
                }, () => {
                    this.getThreadList();
                })
            }
        })

    }
    // 获取话题列表
    getTopicList= async () => {
        const { topic } = this.props;
        let { topicPage, topicPerPage, searchTopicList } = this.state;
        if (topic && topic.getTopicList) {
            const res = await topic.getTopicList({
                'page[number]': topicPage,
                'page[size]': topicPerPage,
                'filter[name]': this.searchValue,
                meta: 'page.total'
            });
            topic.listStore.getList({ namespace: 'topicList' }) || [];
            console.log(res,'话题数据');
            if(res.code == 0) {
                // 如果是第一页，替换数据；否则追加数据
                const newTopicList = topicPage === 1 ? res.data?.data : [...searchTopicList, ...res.data?.data];
                this.setState({
                    searchTopicList: newTopicList,
                    topicTotalCount: res.data?.page?.total
                })
            }
            
        }
    }

    // 获取用户列表
    getUserList = async () => {
        const { user } = this.props;
        let { userPage, userPerPage, searchUserList } = this.state;
        if (user) {
            this.setState({ loading: true });
            try {
                const res = await user.fetchSearchUsersList({
                    page: userPage,
                    perPage: userPerPage,
                    'filter[nickname]': this.searchValue
                });
                user.listStore.getList({ namespace: this.namespace }) || [];
                console.log(res,'用户数据');
                if(res.code == 0) {
                    const newUserList = userPage === 1 ? res.data?.pageData : [...searchUserList, ...res.data?.pageData];
                    this.setState({
                        searchUserList: newUserList,
                        userTotalCount: res.data?.totalCount
                    })
                }
            } finally {
                this.setState({ loading: false });
            }
        }
    }

    // 获取活动列表
    getActivityList = async () => {
        const { activity } = this.props;
        let { activityPage, activityPerPage, searchActivityList } = this.state;
        if(activity) {
            let params:any = {
                'page[number]': activityPage,
                'page[size]': activityPerPage,
                'filter[title]': this.searchValue,
                meta: 'page.total'
            }
            const res:any = await activity.getActivityList(params)
            console.log(res, '活动数据11');
            if(res.code == 0) {
                // 如果是第一页，替换数据；否则追加数据
                const newActivityList = activityPage === 1 ? res.data?.data : [...searchActivityList, ...res.data?.data];
                this.setState({
                    searchActivityList: newActivityList,
                    activityTotalCount: res.data?.page?.total
                })
            }
        }

    }
    // // 只获取数据，不渲染
    getActivityListData = () => {
        const { activity } = this.props;
        if (!activity || !activity.listStore) return [];
        const list = activity.listStore.lists[this.namespace];
        if (!list) return [];
        return activity.listStore.getList({ namespace: this.namespace });
    }

    // 获取帖子列表
    getThreadList = async () => {
        const { thread } = this.props;
        let { threadPage, threadPerPage, searchThreadList} = this.state;
        if (thread && thread.getThreads) {
            const res:any = await thread.getThreads({
                'page[number]': threadPage,
                'page[size]': threadPerPage,
                'filter[title]': this.searchValue,
                meta: 'page.total'
            }, this.namespace);
            console.log(res,'帖子数据')
            // 如果是第一页，替换数据；否则追加数据
            const newThreadList = threadPage === 1 ? res.data?.data : [...searchThreadList, ...res.data?.data];
            this.setState({ 
                searchThreadList: newThreadList, 
                threadTotalCount: res.data?.page?.total
            });
        }
        if (!thread || !thread.listStore) return [];
        const list = thread.listStore.lists[this.namespace];
        if (!list) return [];
        return thread.listStore.getList({ namespace: this.namespace });
    }

    // 添加获取列表状态的方法  navCurrentIndex为 1是话题，2是用户，3是活动，4是帖子
    getListState = () => {
        const { navCurrentIndex } = this.state;
        const { namespace } = this;
        const { topic, user, activity, thread } = this.props;

        if (navCurrentIndex === 2) {
            const { searchUserList, userTotalCount, userPerPage, loading } = this.state;
            const listLength = Array.isArray(searchUserList) ? searchUserList.length : 0;
            const total = typeof userTotalCount === 'number' ? userTotalCount : Number(userTotalCount);

            let hasMore = false;
            if (Number.isFinite(total) && total > 0) {
                hasMore = listLength < total;
            } else if (listLength > 0 && userPerPage > 0) {
                // totalCount 缺失时：如果当前条数仍是整页，认为可能还有下一页
                hasMore = listLength % userPerPage === 0;
            }

            return { loading: !!loading, hasMore };
        }
        
        if (navCurrentIndex === 0) {
            return { loading: false, hasMore: false };
        }
        
        const storeMap = {
            1: topic,  // 话题
            2: user,   // 用户
            3: activity, // 活动
            4: thread  // 帖子
        };
        
        const store = storeMap[navCurrentIndex];
        if (!store || !store.listStore) {
            return { loading: false, hasMore: false };
        }
        
        const list = store.listStore.lists[namespace];
        if (!list) {
            return { loading: false, hasMore: false };
        }
        
        return {
            loading: list.loading || false,
            hasMore: list.hasMore || false
        };
    }

    // 处理加载更多
    handleLoadMore = async () => {
        const { navCurrentIndex } = this.state;
        
        if (navCurrentIndex === 0) {
            console.log('当前为默认导航，不需要分页加载');
            return;
        }

        if (navCurrentIndex === 1) {
            // 话题
            const { topicPage } = this.state;
            this.setState({ topicPage: topicPage + 1 }, () => {
                this.getTopicList();
            });
        } else if (navCurrentIndex === 2) {
            // 用户
            const { userPage } = this.state;
            this.setState({ userPage: userPage + 1 }, () => {
                this.getUserList();
            });
        } else if (navCurrentIndex === 3) {
            // 活动
            const { activityPage } = this.state;
            this.setState({ activityPage: activityPage + 1 }, () => {
                this.getActivityList();
            });
        } else if (navCurrentIndex === 4) {
            // 帖子
            const { threadPage } = this.state;
            this.setState({ threadPage: threadPage + 1 }, () => {
                this.getThreadList();
            });
        }
    }


    render() {
        const { app, thread, user } = this.props;
        const platform = app?.platform || 'h5';
        let { navList, navCurrentIndex, searchTopicList, topicTotalCount, searchUserList, userTotalCount, searchActivityList, activityTotalCount, searchThreadList, threadTotalCount } = this.state;
        // 从状态获取 loading 和 hasMore
        const { loading, hasMore } = this.getListState();

        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (
                <div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                    {platform === 'pc' ? (
                        <PC
                            namespace={this.namespace}
                            loading={loading}
                            hasMore={hasMore}
                            onLoadMore={this.handleLoadMore}
                            userInfo={user}
                            searchValue={this.searchValue}
                            navList={navList}
                            navClick={this.navClick}
                            navCurrentIndex={navCurrentIndex}
                            searchTopicList={searchTopicList}
                            topicTotalCount={topicTotalCount}
                            searchUserList={searchUserList}
                            userTotalCount={userTotalCount}
                            createFollowUser={() => this.createFollowUser}
                            followDelete={() => this.followDelete}
                            searchActivityList={searchActivityList}
                            activityTotalCount={activityTotalCount}
                            searchThreadList={searchThreadList}
                            threadTotalCount={threadTotalCount}
                        />
                    ) : (
                        <H5
                            namespace={this.namespace}
                            loading={loading}
                            hasMore={hasMore}
                            onLoadMore={this.handleLoadMore}
                            userInfo={user}
                            searchValue={this.searchValue}
                            navList={navList}
                            navClick={this.navClick}
                            navCurrentIndex={navCurrentIndex}
                            searchTopicList={searchTopicList}
                            topicTotalCount={topicTotalCount}
                            searchUserList={searchUserList}
                            userTotalCount={userTotalCount}
                            searchActivityList={searchActivityList}
                            activityTotalCount={activityTotalCount}
                            searchThreadList={searchThreadList}
                            threadTotalCount={threadTotalCount}
                        />
                    )}

                </div>
            )
        }

    }
}

export default withRouter(Search);